import { api } from './api';
import type {
  CreateChatReportPayload,
  CreateChatReportResponse,
  CreatePlayerReportPayload,
  CreatePlayerReportResponse,
} from '@draughts/shared';

// Same rule as review-api: everything goes through `api` (services/api.ts), never
// a bare fetch(), so the Authorization header and the 401 → refresh → retry
// interceptor apply.
//
// Le due funzioni qui sotto NON hanno la stessa porta: dalla chat puo' segnalare
// anche un ospite, dal profilo no. Il perche' sta accanto alle due rotte, in
// packages/server/src/moderation/moderation.routes.ts.

/**
 * File an abuse report against the opponent of a live game room.
 *
 * The payload deliberately carries no evidence: the server reads the chat
 * transcript from the room itself and resolves who is being reported.
 */
export async function reportChat(payload: CreateChatReportPayload): Promise<string> {
  const res = await api.post<CreateChatReportResponse>('/moderation/chat-reports', payload);
  return res.reportId;
}

/**
 * Segnala un giocatore dal suo profilo pubblico.
 *
 * Al contrario di `reportChat`, questa e' SOLO per account registrati: il
 * server la chiude con `requireRegistered`. Qui non c'e' nessuna partita a
 * legare chi segnala a chi e' segnalato — chiunque potrebbe segnalare chiunque —
 * e un ospite sarebbe un conto usa-e-getta, cioe' zero attrito per chi vuole
 * fare rumore. Il motivo per cui in chat gli ospiti possono segnalare e' scritto
 * accanto alle due rotte, in moderation.routes.ts.
 *
 * Viaggia il NOME, non un id: il profilo pubblico non espone lo userId, e il
 * server lo risolve da se'.
 */
export async function reportPlayer(payload: CreatePlayerReportPayload): Promise<string> {
  const res = await api.post<CreatePlayerReportResponse>('/moderation/player-reports', payload);
  return res.reportId;
}
